(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.athleteSwiper', {
    // Feel
    speed: 600,
    grabCursor: true,
    resistanceRatio: 0.85,

    // Free-mode with momentum + soft snap
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.8,
      momentumVelocityRatio: 0.7,
      sticky: true // snaps to the nearest slide smoothly
    },

    // Interaction
    mousewheel: { forceToAxis: true, releaseOnEdges: true, sensitivity: 0.8 },
    keyboard: { enabled: true, onlyInViewport: true },

    // Layout
    slidesPerView: 'auto',
    spaceBetween: 24,
    centeredSlidesBounds: true,
    watchSlidesProgress: true,
    watchOverflow: true,

    // Performance
    preloadImages: false,
    lazy: { loadPrevNext: true, loadOnTransitionStart: true },
    updateOnWindowResize: true,
    observer: true,
    observeParents: true,

    // Accessibility
    a11y: { enabled: true },

    // Optional pagination (add .swiper-pagination in your markup if you want dots)
    // pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },

    breakpoints: {
      320:  { slidesPerView: 1.15, spaceBetween: 16 },
      768:  { slidesPerView: 2.25, spaceBetween: 20 },
      1024: { slidesPerView: 3.15, spaceBetween: 24 },
      1280: { slidesPerView: 3,    spaceBetween: 32 }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
